var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my_border_box_2"},[_c('div',{staticClass:"my_border_box_3"},[_c('div',{staticClass:"my_border_box_4"})])])
}]

export { render, staticRenderFns }